



























import {
  Vue,
  Component,
  Prop,
  Emit,
} from 'vue-property-decorator';
import DoughnutChart from '@/components/DoughnutChart.vue';
import RedMeaning from '@/components/PersonalityColorMeaning/Red.vue';
import BlueMeaning from '@/components/PersonalityColorMeaning/Blue.vue';
import GreenMeaning from '@/components/PersonalityColorMeaning/Green.vue';
import YellowMeaning from '@/components/PersonalityColorMeaning/Yellow.vue';
import {
  PersonalityTestResponse,
  PersonalityTestResult,
  PersonalityColor,
  TestWordGroup,
} from '../../types';

/**
 * This component is showing the results of the profile test
 * It uses the doughnut chart component to show the color landscape of the user
 * It also shows the meaning behind these colors
 */
@Component({
  components: {
    DoughnutChart,
    RedMeaning,
    BlueMeaning,
    GreenMeaning,
    YellowMeaning,
  },
})
export default class PersonalityTestResultView extends Vue {
  private result: PersonalityTestResult = {
    [PersonalityColor.Red]: 0,
    [PersonalityColor.Green]: 0,
    [PersonalityColor.Blue]: 0,
    [PersonalityColor.Yellow]: 0,
  };

  private dominantColor!: PersonalityColor;

  private chartData!: Record<string, unknown>;

  private personalityColors: string[] = [];

  private chartOptions: Record<string, unknown> = {
    legend: {
      display: false,
    },
    responsive: true,
    maintainAspectRatio: true,
    plugins: {
      datalabels: {
        color: '#fff',
      },
    },
  };

  @Prop({ type: Array, required: true })
  private readonly groups!: TestWordGroup[];

  @Prop({ type: Map, required: true })
  private readonly response!: PersonalityTestResponse;

  private created() {
    this.buildTestResult();
    this.fillChartData();

    this.personalityColors = Object.keys(this.result);
  }

  private isColorDominant(color: PersonalityColor) {
    return this.dominantColor === color;
  }

  private getKeyResultByOrder(): string[] {
    const keys: PersonalityColor[] = Object.keys(this.result) as PersonalityColor[];
    keys.sort((a, b) => this.result[b] - this.result[a]);
    return keys;
  }

  private buildTestResult() {
    this.response.forEach((value, key) => {
      const item = this.groups[key].find((groupItem) => groupItem.id === value);

      if (!item) {
        return;
      }

      const colorEnumKey: PersonalityColor = item.color;

      // eslint-disable-next-line
      this.result[colorEnumKey] += 1;
    });

    [this.dominantColor] = this.getKeyResultByOrder() as PersonalityColor[];
  }

  @Emit('review-test')
  private triggerReview(): boolean {
    /* eslint class-methods-use-this: 0 */
    return true;
  }

  private fillChartData() {
    const colors = {
      [PersonalityColor.Red]: '#FF4136',
      [PersonalityColor.Green]: '#2ECC40',
      [PersonalityColor.Blue]: '#0074D9',
      [PersonalityColor.Yellow]: '#FFDC00',
    };

    const keys = this.getKeyResultByOrder() as PersonalityColor[];

    // Removed 0 scores for any personality color
    const chartKeys = keys.filter((k: PersonalityColor) => this.result[k] > 0);

    this.chartData = {
      labels: chartKeys,
      datasets: [
        {
          backgroundColor: chartKeys.map((k: PersonalityColor) => colors[k] || '#ddd'),
          data: chartKeys.map((k) => this.result[k]),
        },
      ],
    };
  }
}
